<template>
  <mdb-container>
    <div>
      <mdb-card class="mb-4 text-center">
        <mdb-card-header class="primary-color text-white">
          {{ event.meta.goingLabel }} <span v-html="event.displayDate"/>
          <div>
            <mdb-btn :disabled="executing" @click="doCancel" rounded size="sm">
              <mdb-icon icon="arrow-left"/>
              Back to Main
            </mdb-btn>
            <div v-if="group && group.role != 'Public'">
              <mdb-btn :disabled="executing" @click="hideNotGoing=true" icon="eye-slash"
                       rounded
                       size="sm"
                       v-if="!hideNotGoing && !managingWaitlist">Hide 'No' Responses
              </mdb-btn>
              <mdb-btn :disabled="executing" @click="hideNotGoing=false" icon="eye"
                       rounded
                       size="sm"
                       v-if="hideNotGoing &&!managingWaitlist">Show 'No' Responses
              </mdb-btn>
              <mdb-btn :disabled="executing" @click="manageWaits" icon="user-clock"
                       rounded
                       size="sm"
                       v-if="!managingWaitlist && admin && showOrgTools">Manage Waitlist
              </mdb-btn>
              <mdb-btn :disabled="executing" @click="normalView" icon="users"
                       rounded
                       size="sm"
                       v-if="managingWaitlist && admin && showOrgTools">Normal View
              </mdb-btn>
              <mdb-btn @click="download" icon="download" rounded size="sm">Download</mdb-btn>
              <mdb-btn @click="print" icon="print" rounded size="sm">Printable Version</mdb-btn>
            </div>

          </div>
        </mdb-card-header>
      </mdb-card>
      <div v-if="rsvpModal">
        <rsvp-controls
          :event="event" :memberId="currentMember.id"
          @rsvpCanceled="rsvpCanceled" @rsvpChanged="rsvpChanged" mode="admin"
        />
      </div>

      <mdb-card v-if="admin && showOrgTools">
        <mdb-card-body>
          <mdb-input @input="isTyping = true" aria-label="Find a Member to Add" label="Add Member"
                     placeholder="Type member name to add" type="text"
                     v-model="query"/>
          <div class="text-left" v-if="managingWaitlist && event.meta.waitlistRule != 'Manual'">
            Waitlist Rule: {{ event.meta.waitlistRule }}
            <mdb-btn @click="processWaitlist" icon="user-clock" rounded size="sm">Process Waitlist</mdb-btn>
            <div>
              <small>Any action you take here will not invoke automated waitlist processing. Hit the "Process Waitlist"
                button
                to fill any open spots because of changes you made here.</small>
            </div>
          </div>
          <mdb-row v-if="query">
            <div :key="m.id" class="col-md-3 d-flex align-self-stretch"
                 v-for="m in memberList">
              <div class="card profile-card text-center mb-4 animated slideInDown">
                <div class="avatar mb-4">
                  <a :title="m.name" @click="showMember(m)" role="button">
                    <avatar :avatar="m.avatar" :reputation="m.reputation"
                            :size="100" containerClass=""/>
                  </a>
                </div>
                <div class="card-body pt-0 mt-0">
                  <h3 class="mb-3 font-weight-bold"><strong>{{ m.name }}</strong></h3>
                  <div v-if="admin">
                    <mdb-btn class="fixed-width-button" @click="waitlist(m,true)" color="danger" icon="plus-circle" rounded size="sm">
                      {{$t("page.event.putOnWaitlist")}}
                    </mdb-btn>
                    <mdb-btn class="fixed-width-button" @click="going(m,true)" color="success" icon="check-circle" rounded size="sm">
                      {{$t("page.event.setGoing")}}
                    </mdb-btn>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="memberList.length == 0">
              <div class="text-warning">Member not found</div>
            </div>
          </mdb-row>
          <mdb-btn :disabled="executing" @click="doCancelSearch" color="success" icon="times-circle"
                   v-if="memberList.length>0">Done
          </mdb-btn>
          <mdb-btn v-if="queryTotal > 10 && memberList.length >= 10 " :disabled="executing" @click="nextPage" color="success" icon="arrow-right">
            Load More
          </mdb-btn>
          <mdb-btn v-if="resultsPage > 0 " :disabled="executing" @click="previousPage" color="success" icon="arrow-left">
            Previous
          </mdb-btn>
        </mdb-card-body>
      </mdb-card>
      <mdb-row>
        <div :key="m.id" class="col-md-3 d-flex align-self-stretch"
             v-for="m in attendees"
             v-if="( (m.status != 'Not Going' || !hideNotGoing) && !managingWaitlist) || ( m.status=='Waiting' && managingWaitlist)">
          <div class="card profile-card text-center mb-4 animated slideInDown">
            <div class="avatar mb-4">
              <a :title="m.name" @click="showMember(m)" role="button">
                <avatar :avatar="m.avatar" :reputation="m.reputation"
                        :size="100" containerClass=""/>
              </a>
            </div>
            <div class="badge-container">
              <mdb-badge :color="m.badgeType" v-if="m.badge">
                <mdb-icon class="mr-1" icon="clock" v-if="m.badgeType=='warning'"/>
                <mdb-icon class="mr-1" icon="thumbs-up" v-if="m.badgeType=='success'"/>
                <mdb-icon class="mr-1" icon="ban" v-if="m.badgeType=='danger'"/>
                {{ m.badge }}
              </mdb-badge>
            </div>
            <div class="card-body pt-0 mt-0">
              <h3 class="mb-3 font-weight-bold"><strong>{{ m.name }}</strong></h3>
              <h5 v-if="m.title">{{ m.title }}</h5>
              <div :key="i" class="text-primary" v-for="(guest,i) in m.guestNames">
                <i class="fal fa-user-plus"></i>&nbsp;{{ guest }}
              </div>
              <div class="small">Reserved <span v-html="m.reserved"/></div>
              <div class="small" v-if="m.updated && m.updated != m.reserved">Updated <span v-html="m.updated"/></div>
              <div class="small" v-if="!m.updated || m.updated == m.reserved">&nbsp;<!--Keep alignment--></div>

              <div class="small" v-if="admin && showOrgTools && m.locked">
                If you need to change your own participation, please let a group organizer or administrator know so
                plans can be made.
              </div>

              <div v-if="admin && showOrgTools && !m.locked">
                <div v-if="event.hasFee">
                  <b><i>
                    <span v-if="m.balance">Owes {{ m.balance }}</span>
                  </i></b>
                </div>
                <mdb-btn class="fixed-width-button" @click="change(m)" color="warning" icon="pencil" rounded size="sm" v-if="m.status=='Going'">
                  Change
                </mdb-btn>
                <mdb-btn class="fixed-width-button" @click="notGoing(m,false)" color="danger" icon="times-circle" rounded size="sm">{{$t("page.event.setNotGoing")}}
                </mdb-btn>
                <mdb-btn class="fixed-width-button" @click="waitlist(m,false)" color="danger" icon="plus-circle" rounded size="sm"
                         v-if="m.status=='Going'">{{$t("page.event.putOnWaitlist")}}
                </mdb-btn>
                <mdb-btn class="fixed-width-button" @click="going(m)" color="success" icon="check-circle" rounded size="sm"
                         v-if="m.status!='Going'">{{$t("page.event.setGoing")}}
                </mdb-btn>
              </div>
            </div>
          </div>
        </div>

      </mdb-row>
      <member-modal :id="memberModalId" @modalClosed="modalClosed"/>
      <processing-modal v-if="processingModal" :message="processingMessage" />
    </div>
  </mdb-container>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import Avatar from "../common/Avatar"
import MemberModal from "../group/MemberModal"
import rsvpControls from "./RsvpControls"
import download from 'js-file-download'
import ProcessingModal from "../common/ProcessingModal";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbRow
} from 'mdbvue';

export default {
  name: 'Event-Attendees-Editor',
  components: {
    mdbBtn,
    mdbIcon,
    mdbInput,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbContainer,
    mdbBadge,
    Avatar,
    MemberModal,
    rsvpControls,
    ProcessingModal
  },
  props: {
    event: {
      type: Object,
      default: []
    },
    attendees: {
      type: Array,
      default: []
    },
    admin: {
      type: Boolean,
      default: false
    },
    showOrgTools: {
      type: Boolean,
      default: true
    },
    startView: {
      type: String,
      default: null
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    group() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    },
    settings() {
      return this.$store.state.settings
    },
    url() {
      return process.env.BACKEND_URL
    }
  },
  watch: {
    query: _.debounce(function () {
      this.isTyping = false;
    }, 790),
    isTyping: function (value) {
      if (!value) {
        this.loadMemberList(true)
      }
    }
  },
  data() {
    return {
      query: "",
      isTyping: false,
      memberList: [],
      queryTotal: 0,
      resultsPage: 0,
      saveAction: null,
      saveHost: null,
      stillGoing: false,
      memberModalId: null,
      rsvpModal: false,
      currentMember: null,
      hideNotGoing: true,
      managingWaitlist: false,
      processingModal: false,
      processingMessage: ""
    }
  },
  mounted() {
    if (this.startView == "waitlist") this.manageWaits()
  },
  methods: {
    manageWaits() {
      this.attendees = this.attendees.sort((a, b) => (a.reservedSort > b.reservedSort) ? 1 : ((b.reservedSort > a.reservedSort) ? -1 : 0))
      this.managingWaitlist = true
      window.scrollTo(0,0)
    },
    normalView() {
      this.attendees = this.attendees.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      this.managingWaitlist = false
    },
    change(m) {
      this.currentMember = m
      this.rsvpModal = true
    },
    processWaitlist() {
      this.$store.dispatch("setExecuting", false)
      api.post("/event/processWaitlist/" + this.event.eventId).then(
        (results) => {
          this.$emit("needReload")
        },
        (error) => {
          this.$notify.error({message: "Could not load rules. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    rsvpChanged: function () {
      this.rsvpModal = false
      this.$store.dispatch("setExecuting", false)
      api.get("/reservation/details/" + this.event.eventId + "/?member=" + this.currentMember.id).then(
        (results) => {
          for (let i = 0; i < this.attendees.length; i++) {
            let a = this.attendees[i]
            if (a.id == results.data.id) {
              a.guests = results.data.guests
              a.badge = results.data.badge
              a.badgeType = results.data.badgeType
              a.updated = results.data.updated
              a.balance = results.data.balance
              a.charged = results.data.charged
              a.guestNames = results.data.guestNames
            }
          }
          this.currentMember = null
        },
        (error) => {
          this.$notify.error({message: "Could not load rules. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    rsvpCanceled: function () {
      this.rsvpModal = false
      this.currentMember = null
    },
    modalClosed: function () {
      this.memberModalId = null
    },
    showMember: function (host) {
      if (this.group.role == "Public") return;
      this.memberModalId = host.id
    },
    nextPage() {
      this.resultsPage++
      this.loadMemberList(false)
      window.scrollTo(0,0)
    },
    previousPage() {
      this.resultsPage--
      this.loadMemberList(false)
      window.scrollTo(0,0)
    },
    loadMemberList(reset) {
      if (reset) this.resultsPage = 0
      if (!this.query) return
      this.memberList = []
      this.$store.dispatch("setExecuting", true)
      api.get("/member/lookup/" + this.group.vanityPath + "/?q=" + this.query + "&offset=" + this.resultsPage * 10).then(
        (results) => {
          this.queryTotal = results.data.total
          for (let i = 0; i < results.data.members.length; i++) {
            let row = results.data.members[i]
            if (!this.isInList(row.id)) this.memberList.push(row)
          }
        },
        (error) => {
          this.$notify.error({message: "Could not load members. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    isInList(id) {
      let found = false
      for (let i = 0; i < this.attendees.length; i++) {
        if (this.attendees[i].id == id && this.attendees[i].status == 'Going') {
          found = true
        }
      }
      return found
    },

    doCancel() {
      this.$emit("cancel")
    },
    doCancelSearch() {
      this.memberList = []
      this.query = ""
      window.scrollTo(0,0)
    },
    waitlist(member, newRec) {
      this.$store.dispatch("setExecuting", true);
      api.post('/reservation/adminWaitlist/' + this.event.eventId + "/?member=" + member.id, {}).then(
        (results) => {
          member.status = "Waiting"
          member.badge = "Waiting"
          member.badgeType = "warning"
          if (newRec) {
            this.attendees.unshift(results.data)
            this.memberList = []
            this.query = ""
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });

    },
    /*async print() {
      this.processingMessage = "Fetching report data..."
      this.processingModal = true
      let request
      await api.get('/event/attendeeReportData/' + this.event.eventId).then(
        (results) => {
          this.processingMessage = "Generating report..."
          request = {
            "renderRequest": {
              "template": {
                "name": results.data.event.template
              },
              "data": results.data
            }
          };
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
          this.processingModal = false
        });
      if (request) {

        await axios.post(this.settings.reportsUrl, request).then(
          (results) => {
            let link = document.createElement('a');
            link.style.display = 'none'
            link.download = 'event_' + this.event.eventId + '_attendees.pdf';
            link.href = 'data:application/octet-stream;base64,' + results.data;
            document.body.appendChild(link);
            this.processingModal = false
            link.click();
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
            this.processingModal = false
          });
      }
    },*/
    print() {
      this.$store.dispatch("setExecuting", true);
      api.post('/user/oneLaunch/?target=/event/printRoster/' + this.event.eventId).then(
        (results) => {
          var wnd = window.open(results.data, "", "_blank");
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    },
    notGoing(member) {
      this.$store.dispatch("setExecuting", true);
      api.post('/reservation/adminNotGoing/' + this.event.eventId + "/?member=" + member.id, {}).then(
        (results) => {
          /*let loc = this.attendees.indexOf(member)
           this.attendees.splice(loc, 1)*/
          member.status = "Not Going"
          member.badge = "No"
          member.badgeType = "danger"
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });

    },
    going(member, newRec) {
      this.$store.dispatch("setExecuting", true);
      api.post('/reservation/adminGoing/' + this.event.eventId + "/?member=" + member.id, {}).then(
        (results) => {
          member.status = "Going"
          member.badge = "Yes"
          member.badgeType = "success"
          if (newRec) {
            this.attendees.unshift(results.data)
            this.memberList = []
            this.query = ""
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    },
    download() {
      this.$store.dispatch("setExecuting", true)
      api.get('/event/attendees/' + this.event.eventId + '?format=csv').then(
        (results) => {
          download(results.data, "event_" + this.event.eventId + "_roster.csv")
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
;
</script>
<style scoped>
p {
  line-height: 1em;
  margin-bottom: 5px;
}

@media screen and (max-width: 749px ) {
  .profile-card {
    width: 100%;
  }
}

.profile-card {
  margin-top: 100px;
}

.profile-card .avatar {
  max-width: 150px;
  max-height: 150px;
  margin: -70px auto 0;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}

.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.cascading-admin-card .admin-up .fa, .z-depth-2 {
  -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
}

.badge-container {
  position: absolute;
  right: 0;
}

.list-title-tools {
  position: absolute;
  right: 0;
  top: 0;
  padding-right: 10px;
}

.fixed-width-button {
  width: 90%;
}

</style>
